// import verifyOtp from "./verifyOtp";
// import passwordReset from "./passwordReset"
import welcome from "./welcome";

const EmailPreview = () => {
  const html = welcome("Winnie");

  return <div dangerouslySetInnerHTML={{ __html: html }} />;
};

export default EmailPreview;
